namespace Areas {
    "use strict";

    export class FormCrudOperations {

        form: DevExpress.ui.dxForm;
        area: string;
        getMoreData: (any) => void;

        constructor(area: string, getMoreData?: (any) => void) {
            const formId = `#${area}Form`;
            this.form = $(formId).dxForm("instance");
            this.area = area;

            if (getMoreData) {
                this.getMoreData = getMoreData;
            }
        }

        insertRecord() {
            const newData: any = this.form.option("formData");

            if (this.getMoreData) {
                this.getMoreData(newData);
            }

            const result: any = this.form.validate();

            if (result.isValid) {
                sendRequest(`/${this.area}/Create/Post`, JSON.stringify(newData), "POST");
            }
        }

        updateRecord() {
            const newData: any = this.form.option("formData");

            if (this.getMoreData) {
                this.getMoreData(newData);
            }

            const result: any = this.form.validate();
            const keyId: any = this.form.option("KeyId");

            if (result.isValid && keyId != null) {
                sendRequest(`/${this.area}/Edit/Put/${keyId}`, JSON.stringify(newData), "PUT");
            }
        }

        deleteRecord() {
            const verifyVoid = window.confirm("Are you sure you would like to VOID this record?");

            if (verifyVoid) {
                const keyId: any = this.form.option("KeyId");
                if (keyId != null) {
                    sendRequest(`/${this.area}/Edit/Delete/${keyId}`, "", "DELETE");
                }
            }
        }
    }








}
